import {
  HStack,
  Popover,
  PopoverBody,
  PopoverContent,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Text,
  Tooltip,
  useDisclosure,
  PopoverAnchor,
  Box,
  Button,
} from '@chakra-ui/react';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from 'src/components/common/icon/SparkelIcon';
import { useSheetViewerV2 } from 'src/components/viewers/SheetsViewerV2/hooks/useSheetViewerV2';

export function PDFOpacitySlider() {
  const { pdfGhosting } = useSheetViewerV2();
  const { t } = useTranslation('project');

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Popover isOpen={isOpen} onClose={onClose}>
      <PopoverAnchor>
        <Box>
          <Tooltip label={t('viewer-interactions.pdf-opacity')}>
            <Button
              aria-label={t('viewer-interactions.pdf-opacity')}
              leftIcon={<SparkelIcon icon={faEyeSlash} />}
              colorScheme="gray"
              variant="solid-no-transparent"
              size="xs"
              onClick={onOpen}
              width="75px"
            >
              {`${pdfGhosting.opacity}%`}
            </Button>
          </Tooltip>
        </Box>
      </PopoverAnchor>
      <PopoverContent>
        <PopoverBody p={4}>
          <HStack spacing={4}>
            <Slider
              aria-label="pdf-opacity-slider"
              value={pdfGhosting.opacity}
              onChange={pdfGhosting.setOpacity}
              min={0}
              max={100}
              step={5}
              size="sm"
              flex={1}
            >
              <SliderTrack height="6px">
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb boxSize={4} />
            </Slider>
            <Text fontSize="sm" color="gray.500" minW="40px" textAlign="right">
              {`${pdfGhosting.opacity}%`}
            </Text>
          </HStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
